/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */
import { filterActions } from '@zumper/redux-ignore'
import type { ActionTypes as DetailActionTypes } from '../../reducers/types'
import { cancellationReducer } from './reducers/index'
import { default as whitelist } from './reducers/whitelist'

export const cancellation = filterActions<
  ReturnType<typeof cancellationReducer>,
  DetailActionTypes,
  (typeof whitelist)[number]
>(cancellationReducer, whitelist)

export { whitelist }
